import { render, staticRenderFns } from "./ProductListSlider.vue?vue&type=template&id=5d4f10a6&"
import script from "./ProductListSlider.vue?vue&type=script&lang=js&"
export * from "./ProductListSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports